export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB to bytes
export const ACCEPTED_FILE_TYPES = [
  // Case insensitive
  '.zip',
  '.geojson',
  '.kml',
];
